<template>
	<div class="full-width">
		<v-tabs
			dark
			v-model="activeTab"
			slider-color="yellow"
			:color="themeInputColor"
		>
			<v-tab
				v-for="(tab, i) in tabs"
				:key="i"
				:href="'#tab-' + i"
				:ripple="false"
				class="px-3"
			>
				{{ tab.name }}
			</v-tab>
		</v-tabs>

		<v-tabs-items v-model="activeTab">
			<v-tab-item value="tab-0">
				<v-container fluid fill-height class="pa-2">
					<v-flex xs12>
						<v-card>
							<dstr-sign-verify
								:title="tabs[0].name"
								:themeInputColor="themeInputColor"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-1">
				<v-container fluid fill-height class="pa-2">
					<v-flex xs12>
						<v-card>
							<dstr-invoice-verify
								:title="tabs[1].name"
								:themeInputColor="themeInputColor"
								appType="fantasy"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-2">
				<v-container fluid fill-height class="pa-2">
					<v-flex xs12>
						<v-card>
							<dstr-invoice-verify
								:title="tabs[2].name"
								:themeInputColor="themeInputColor"
								appType="rummy"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>

<script>
import { themeInputColor } from "@/utils";
import DstrSignVerify from "./dstr-sign-verify.vue";
import DstrInvoiceVerify from "./dstr-invoice-verify.vue";

export default {
	name: "RetailAdminTools",
	props: [],
	data() {
		return {
			activeTab: "tab-0",
			themeInputColor,
			tabs: [
				{ name: "DSTR Signature Approval" },
				{ name: "GST Invoice Verification - Fantasy" },
				{ name: "GST Invoice Verification - Rummy" }
			]
		};
	},
	components: {
		"dstr-sign-verify": DstrSignVerify,
		"dstr-invoice-verify": DstrInvoiceVerify
	}
};
</script>
